var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-guarantee-list',{attrs:{"breakpoints":_vm.breakpoints,"text-for-brand":"Picooc","text-for-year":"до 2 лет","custom-text":{
        guarantee:
            '12&nbsp;месяцев на&nbsp;массажеры и&nbsp;24&nbsp;месяца на&nbsp;умные весы и&nbsp;монитор давления',
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }